export default __webpack_public_path__ + "static/media/human.440047f1.png";